import React, { useEffect } from "react";
import { UAParser } from "ua-parser-js";

interface DeviceInfoProps {
  onMessageChange: (message: string) => void;
}

const DeviceInfo: React.FC<DeviceInfoProps> = ({ onMessageChange }) => {
  useEffect(() => {
    const parser = new UAParser();
    const result = parser.getResult();

    const browser = result.browser.name || "Unknown Browser";
    const os = result.os.name || "Unknown OS";
    const deviceType =
      result.device.type === "mobile"
        ? "Mobile"
        : result.device.type === "tablet"
        ? "Tablet"
        : "Desktop";

    let deviceName = "Unknown Device";
    if (result.device.vendor && result.device.model) {
      deviceName = `${result.device.vendor} ${result.device.model}`;
    } else {
      if (os === "Windows") deviceName = "Windows PC";
      else if (os === "Mac OS" || os === "MacOS") deviceName = "MacBook / iMac";
      else if (os === "Linux") deviceName = "Linux PC";
    }

    const now = new Date();
    const dateTime = now.toLocaleString();

    const sendMessage = (location: string) => {
      const msg = `Date & Time: ${dateTime}
Browser: ${browser}
OS: ${os}
Device Type: ${deviceType}
Device Name: ${deviceName}
Location: ${location}`;
      onMessageChange(msg);
    };

    // ✅ This triggers the browser permission popup
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          // console.log("🌍 Geolocation fetched:", latitude, longitude);

          try {
            const res = await fetch(
              `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`
            );
            const data = await res.json();
            const city =
              data.address.city ||
              data.address.town ||
              data.address.village ||
              "Unknown City";
            const state = data.address.state || "Unknown State";
            const country = data.address.country || "Unknown Country";
            sendMessage(`${city}, ${state}, ${country}`);
          } catch {
            sendMessage("Unable to fetch location");
          }
        },
        (err) => {
          console.error("❌ Geolocation error:", err);
          sendMessage("Permission denied or location unavailable");
        },
        { enableHighAccuracy: true, timeout: 10000 } // optional
      );
    } else {
      sendMessage("Geolocation not supported");
    }
  }, [onMessageChange]);

  return null;
};

export default DeviceInfo;